import axios from 'axios';

export async function get<T>(
    path: string,
    queryParams?: Record<string, any>
): Promise<T> {
    const { data } = await axios.get(path, {params: queryParams});
    return data;
};

export async function post<T>(
    path: string,
    payload: any
  ): Promise<T> {
    const { data } = await axios.post(path, payload);
    return data;
  }